module.exports = __webpack_public_path__ + "img/logo-leste.db69d998.svg";